export class HttpError extends Error {
    statusCode;
    text;
    payload;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(statusCode, text, payload) {
        super();
        this.statusCode = statusCode;
        this.text = text;
        this.payload = payload;
    }
}
/**
 * Perform an HTTP GET request for a JSON resource.
 * @param request The request to perform.
 */
export const get = (request) => fetchJson({ method: 'GET', ...request });
/**
 * Perform an HTTP POST request to a JSON resource.
 * @param request The request to perform.
 */
export const post = (request) => fetchJson({ method: 'POST', ...request });
/**
 * Perform an HTTP PUT request to a JSON resource.
 * @param request The request to perform.
 */
export const put = (request) => fetchJson({ method: 'PUT', ...request });
/**
 * Perform an HTTP DELETE request to a JSON resource.
 * @param request The request to perform.
 */
// delete is keyword :(
export const destroy = (request) => fetchJson({ method: 'DELETE', ...request });
/**
 * Performs an HTTP request for a JSON resource. It is there for added flexibility in certain cases
 * but usually the `get`/`post`/`put`/`delete` methods here should be cleaner to use.
 *
 * @param baseUrl Base URL
 * @param path Path to attach to the base URL, if any.
 * @param method HTTP method to use for the request.
 * @param queryParams Query params; in theory only for `GET`.
 * @param headers Extra headers to use for the request; useful for authorization for example. Required headers for
 * JSON (such as `Content-Type` or `Accept`) are already handled within.
 * @param body HTTP payload for the request; in theory only for `POST`, `PUT`.
 */
export const fetchJson = async ({ baseUrl, path, method, queryParams, headers, body }) => {
    const url = buildUrl(baseUrl, path, queryParams);
    const request = {
        method,
        headers: {
            'Content-Type': 'application/json',
            // TODO change when implementing PATCH
            'Accept': 'application/json',
            ...(headers || {}),
        },
        body: body ? JSON.stringify(body) : undefined
    };
    const response = await fetch(url, request);
    if (response.status === 204 || Number(response.headers.get('content-length')) === 0) {
        return undefined;
    }
    else if (response.status >= 200 && response.status < 300 && response.ok) {
        return response.json();
    }
    else {
        // WARNING this can't be expressed in Typescript, but: Statuses other than 2xx are rejected with an HttpError.
        const httpError = new HttpError(response.status, await response.text());
        try {
            httpError.payload = JSON.parse(httpError.text);
        }
        catch {
            // Fine, can't parse response as JSON, will assume plain text
        }
        throw httpError;
    }
};
const buildUrl = (baseUrl, path, queryParams) => {
    let url = baseUrl;
    if (!baseUrl.endsWith('/') && path !== undefined) {
        url += '/';
    }
    url += path || '';
    if (queryParams) {
        url += '?' + new URLSearchParams(queryParams).toString();
    }
    return url;
};
//# sourceMappingURL=jsonHttp.js.map